import Vue from 'vue'
export default {
  state: {
    openLoginModal: false,
    openSignupModal: false,
    openCheckoutModal: false,
    searchTerm: '',
    filter: {
      q: null,
      category: null,
      brand: null,
      page: 1,
      per_page: 20,
    },
    filterView:{
      q: null,
      category: null,
      brand: null,
      page: 1,
      per_page: 20,
    }
  },

  mutations: {
    showLoginModal: (state, show) => {
      state.openLoginModal = show
    },
    showSignupModal: (state, show) => {
      state.openSignupModal = show
    },
    showCheckoutModal: (state, show) => {
      state.openCheckoutModal = show
    },

    updateSearchTerm: (state, term) => {
      state.searchTerm = term
    },

    UPDATE_QUERY_FILTER: (state, term) => {
      // Vue.set(state.filter, 'query', term)
      state.filter.q = term
      state.filterView.q = term
    },

    UPDATE_CATEGORY_FILTER: (state, category) => {
      state.filter.category = category ? category.id : null;
      state.filterView.category = category ? category.title : null
    },

    UPDATE_BRAND_FILTER: (state, brand) => {
      state.filter.brand = brand ? brand.id : null;
      state.filterView.brand = brand ? brand.title :null;
    },

    UPDATE_PAGE_FILTER: (state, page) => {
      state.filter.page = page
      state.filterView.page = page
    },

    UPDATE_PER_PAGE_FILTER: (state, per_page) => {
      state.filter.per_page = per_page
      state.filterView.per_page = per_page
    },

   
  },

  actions: {
    localSearch({ commit }, term) {
      commit('updateSearchTerm', term)
    },

    setQueryFilter({ commit }, term) {
      commit('UPDATE_QUERY_FILTER', term)
    },

    setCategoryFilter({ commit }, category) {
      commit('UPDATE_CATEGORY_FILTER', category)
    },

    setBrandFilter({ commit }, brand) {
      commit('UPDATE_BRAND_FILTER', brand)
    },

    setPageFilter({ commit }, page) {
      commit('UPDATE_PAGE_FILTER', page)
    },

    setPerPageFilter({ commit }, per_page) {
      commit('UPDATE_PER_PAGE_FILTER', per_page)
    },

    
  }
}
